import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './controllers/ProtectedRoute';

import Login from './pages/Login';
import Usuarios from './pages/Usuarios';
import Home from './pages/Home';
import Produtos from './pages/produtos/Produtos';
import Sacola from './pages/produtos/Sacola';
import Estoques from './pages/estoques/Estoques';
import Relatorio from './pages/estoques/Relatorio';
import Dashboard from './pages/estoques/Dashboard';
import Conferencia from './pages/estoques/Conferencia';
import Vendas from './pages/Vendas';
import Distribuicoes from './pages/Distribuicoes';
import Distribuicoes2 from './pages/Distribuicoes2';
import SolicitacoesDistribuicao from './pages/SolicitacoesDistribuicao';
import Pedidos from './pages/Pedidos';
import PedidoDetalhe from './pages/PedidoDetalhe';
import PedidosExpedicao from './pages/PedidosExpedicao';
import GiroEstoque from './pages/GiroEstoque';
import Arquivos from './pages/Arquivos';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/usuarios" element={<ProtectedRoute permissionPath="admin"><Usuarios /></ProtectedRoute>} />

        <Route path="/produtos" element={<ProtectedRoute permissionPath="paginas.produtos"><Produtos /></ProtectedRoute>} />
        <Route path="/produtos/sacola" element={<ProtectedRoute permissionPath="produtos.info_addSacola"><Sacola /></ProtectedRoute>} />

        <Route path="/estoques" element={<ProtectedRoute permissionPath="paginas.estoques"><Estoques /></ProtectedRoute>} />
        <Route path="/estoques/relatorio" element={<ProtectedRoute permissionPath="paginas.estoques"><Relatorio /></ProtectedRoute>} />
        <Route path="/estoques/dashboard" element={<ProtectedRoute permissionPath="paginas.estoques"><Dashboard /></ProtectedRoute>} />
        <Route path="/estoques/conferencia" element={<ProtectedRoute permissionPath="paginas.estoques"><Conferencia /></ProtectedRoute>} />

        <Route path="/vendas" element={<ProtectedRoute permissionPath="paginas.vendas"><Vendas /></ProtectedRoute>} />

        <Route path="/distribuicoes" element={<ProtectedRoute permissionPath="paginas.compras"><Distribuicoes /></ProtectedRoute>} />
        <Route path="/distribuicoes2" element={<ProtectedRoute permissionPath="paginas.compras"><Distribuicoes2 /></ProtectedRoute>} />

        <Route path="/solicitacoes_distribuicao" element={<ProtectedRoute permissionPath="paginas.solicitacoes_distribuicao"><SolicitacoesDistribuicao /></ProtectedRoute>} />

        <Route path="/giro_estoque" element={<ProtectedRoute permissionPath="paginas.distribuicoes_vendas"><GiroEstoque /></ProtectedRoute>} />

        <Route path="/pedidos" element={<ProtectedRoute permissionPath="paginas.pedidos"><Pedidos /></ProtectedRoute>} />
        <Route path="/pedidos/:id" element={<ProtectedRoute permissionPath="paginas.pedidos"><PedidoDetalhe /></ProtectedRoute>} />
        <Route path="/pedidos_expedicao" element={<ProtectedRoute permissionPath="paginas.pedidos_expedicao"><PedidosExpedicao /></ProtectedRoute>} />

        <Route path="/arquivos" element={<ProtectedRoute permissionPath="paginas.arquivos"><Arquivos /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
};

export default App;
